var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.style })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"failOnHint":true}!./node_modules/vue-loader/lib?{"failOnHint":true}!./node_modules/vue-monaco-editor/src/Monaco.vue?vue&type=template&id=77d5ad30&
// module id = ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"failOnHint":true}!./node_modules/vue-loader/lib/index.js?{"failOnHint":true}!./node_modules/vue-monaco-editor/src/Monaco.vue?vue&type=template&id=77d5ad30&
// module chunks = 1